import styled from "styled-components/native";
import { color, flexbox, position, space } from "styled-system";
const SafeAreaView = styled.SafeAreaView `
  ${flexbox}
  ${color}
  ${space}
  ${position}
`;
export default SafeAreaView;
